import { IconAds, IconFunnel, IconHome, IconOrders, IconProducts, IconSettings } from "../assets/icons/icons.jsx";
import { GraduationCap, PanelsTopLeft } from "lucide-react";

export const menuItems = [
  {
    path: "/home",
    icon: (active: boolean) => (
      <IconHome color={active ? "#0A0A0A" : "#707070"} />
    ),
    text: "home",
    section: "main",
    disabled: false,
    onClick: () => window.location.href = "/home",
  },
  {
    path: "/orders",
    icon: (active: boolean) => (
      <IconOrders color={active ? "#0A0A0A" : "#707070"} />
    ),
    text: "orders",
    section: "main",
    disabled: false,
    onClick: () => window.location.href = "/orders",
  },
  {
    path: "/products",
    icon: (active: boolean) => (
      <IconProducts color={active ? "#0A0A0A" : "#707070"} />
    ),
    text: "products",
    section: "main",
    disabled: false,
    onClick: () => window.location.href = "/products",
  },
  ...(import.meta.env.VITE_DISABLED_ADS !== "true"
    ? [
        {
          path: "/ads",
          icon: (active: boolean) => (
            <IconAds color={active ? "#0A0A0A" : "#707070"} />
          ),
          text: "ads",
          section: "main",
          disabled: false,
          onClick: () => (window.location.href = "/ads"),
        },
      ]
    : []),
  {
    path: "/funnels",
    icon: (active: boolean) => (
      <IconFunnel color={active ? "#0A0A0A" : "#707070"} />
    ),
    text: "funnels",
    section: "main",
    disabled: false,
    onClick: () => window.location.href = "/funnels",
  },
  {
    path: "/ab-testing",
    icon: (active: boolean) => (
      <PanelsTopLeft className="size-5 ml-[3px]" color={active ? "#0A0A0A" : "#707070"} />
    ),
    text: "ab-testing",
    section: "main",
    disabled: false,
    onClick: () => window.location.href = "/ab-testing",
  },
  {
    path: "/settings",
    icon: (active: boolean) => (
      <IconSettings color={active ? "#0A0A0A" : "#707070"} />
    ),
    text: "settings",
    section: "settings",
    disabled: false,
    onClick: () => window.location.href = "/settings",
  },
  {
    path: "/training",
    icon: (active: boolean) => (
      <GraduationCap color={active ? "#0A0A0A" : "#707070"} />
    ),
    text: "training",
    section: "main",
    disabled: false,
    onClick: () => window.open(import.meta.env.VITE_URL_TRAINING, "_blank")
  }
];
